import React from 'react';
import { ToBillEvent } from '../../../models/Factura';
import Input from '../../Forms/Input';
import { conceptoToTotales } from '../../../utils/calculate.conceptos';
import BillEventsConceptos from './BillEvents.conceptos';
import BillEventsTotales from './BillEvents.totales';

interface BillEventsSecondaryBillsProps {
    toBillEvents: ToBillEvent[];
    // Emitters
    onNotaCreditoEdit: (property: 'serie' | 'folio') => (value: string) => void;
    onCfdiEdit: (property: 'serie' | 'folio') => (value: string) => void;
}

/** Nota de crédito and liquidación waiting to be stamped, serie and folio are editable */
function BillEventsSecondaryBills({ toBillEvents, onNotaCreditoEdit, onCfdiEdit }: BillEventsSecondaryBillsProps) {
    if (!toBillEvents) {
        return null;
    }
    return (
        <>
            {toBillEvents.map((billEvent, i) => {
                const notaTotales = conceptoToTotales(!!billEvent.NotaCreditoCFDI ? billEvent.NotaCreditoCFDI.conceptos : []);
                const cfdiTotales = conceptoToTotales(!!billEvent.CFDI ? billEvent.CFDI.conceptos : []);
                return (
                    <div className="billEventGroupper" key={i}>
                        {
                            !billEvent.NotaCreditoCFDI ?
                                '' :
                                <div>
                                    <h4>Nota de crédito para el adelanto</h4>

                                    <div className="card table">
                                        <div className="cardBody">
                                            <div className="row emisor">
                                                <div className="row two">
                                                    <Input value={billEvent.NotaCreditoCFDI.serie || 'A'} label="Serie" type="text" onChange={onNotaCreditoEdit('serie')} />
                                                    <Input value={billEvent.NotaCreditoCFDI.folio || '1'} label="Folio" type="text" onChange={onNotaCreditoEdit('folio')} />
                                                </div>
                                            </div>
                                            <div className="row emisor">
                                                <Input value={billEvent.NotaCreditoCFDI.receptor.nombre} label="Receptor" type="text" disabled={true} />
                                                <Input value={billEvent.NotaCreditoCFDI.receptor.rfc} label="RFC Receptor" type="text" disabled={true} />
                                                <div className="row two">
                                                    <Input value={billEvent.NotaCreditoCFDI.formaPago} label="Forma de pago" type="text" disabled={true} />
                                                    <Input value={billEvent.NotaCreditoCFDI.metodoPago} label="Metodo de pago" type="text" disabled={true} />
                                                </div>
                                            </div>
                                            <div className="_wrapNota">
                                                <BillEventsConceptos conceptos={billEvent.NotaCreditoCFDI.conceptos} />
                                                <BillEventsTotales totales={notaTotales} gateTotales={cfdiTotales} letraPrefix="Nota de crédito por " />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                        }
                        {
                            !billEvent.CFDI ?
                                '' :
                                <div>
                                    <h4>Factura de liquidación completa</h4>

                                    <div className="card table">
                                        <div className="cardBody">
                                            <div className="_wrapCFDI">
                                                <div className="row emisor">
                                                    <div className="row two">
                                                        <Input value={billEvent.CFDI.serie || 'A'} label="Serie" type="text" onChange={onCfdiEdit('serie')} />
                                                        <Input value={billEvent.CFDI.folio || '1'} label="Folio" type="text" onChange={onCfdiEdit('folio')} />
                                                    </div>
                                                </div>
                                                <div className="row emisor">
                                                    <Input value={billEvent.CFDI.receptor.nombre} label="Receptor" type="text" disabled={true} />
                                                    <Input value={billEvent.CFDI.receptor.rfc} label="RFC Receptor" type="text" disabled={true} />
                                                    <div className="row two">
                                                        <Input value={billEvent.CFDI.formaPago} label="Forma de pago" type="text" disabled={true} />
                                                        <Input value={billEvent.CFDI.metodoPago} label="Metodo de pago" type="text" disabled={true} />
                                                    </div>
                                                </div>
                                                <BillEventsConceptos conceptos={billEvent.CFDI.conceptos} />
                                                <BillEventsTotales totales={cfdiTotales} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                        }
                    </div>
                )
            })}
        </>
    )
}

export default BillEventsSecondaryBills;
